import {WATERSPEED_APP_STORE_LINK, WATERSPEED_PLAY_STORE_LINK} from "constants/AppConstants.js";

export const isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
export const isAndroidDevice = /Android/.test(navigator.userAgent);

/** Store this device can install from, or null on desktop. */
export const mobileStoreLink = (): string | null => {
  if (isIOSDevice) {
    return WATERSPEED_APP_STORE_LINK;
  }
  return isAndroidDevice ? WATERSPEED_PLAY_STORE_LINK : null;
};
